import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UserStore } from '@/app/lib/store';

const pages: any[] = [
  {
    path: '',
    redirectTo: '/auctions',
  },
  {
    path: 'auctions',
    loadComponent: () => import('@/app/pages/auctions/auctions.component').then((c) => c.AuctionsComponent),
  },
  {
    path: 'lots/:auctionId',
    loadComponent: () => import('@/app/pages/lots/lots.component').then((c) => c.LotsComponent),
  },
  {
    path: 'bids/:auctionId/:lotId',
    loadComponent: () => import('@/app/pages/bids/bids.component').then((c) => c.BidsComponent),
  },
];

export const routes: any[] = [
  ...pages,
].map((page) => {
  if (page.redirectTo) {
    return {
      ...page,
      pathMatch: page.pathMatch ?? 'full',
    };
  } else {
    return {
      ...page,
      canActivate: [
        MsalGuard,
        () => {
          const router = inject(Router);
          const userStore = inject(UserStore);
          const isAuthenticated = userStore.isAuthenticated();
          if (!isAuthenticated) {
            return true;
          }

          // we do not have additional roles for now, so we can skip this check
          return true;
        },
      ],
    };
  }
});
